import exceljs from "exceljs";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    MyDate, mimeTypeMap, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Export({
    filterUserList
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const exportFunc = () => {
        if(!filterUserList.length){
            window.alert("No data to export.");
            return;
        }
        setShowLoader(true);
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const worksheet = workbook.addWorksheet("My Sheet", {views: [{showGridLines: false}]});
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57;
        const rows = filterUserList.map(post => [
            post.projectName, 
            post.startDate ?? "",
            post.endDate ?? "",
            post.stats,
            post.code,
            post.priority,
            post.pending,
            post.sup,
            post.pdfId?{formula: `HYPERLINK("https://drive.google.com/uc?export=download&id=${post.pdfId}", "File")`}:"",
            post.reportTech,
            post.status,
            post.notes,
            post.projectManager, 
            post.approverNotes, 
            post.submitter,
            !post.submitTime?"":new Date(post.submitTime.replace(/-/g, "/")), 
            post.updater, 
            !post.updateTime?"":new Date(post.updateTime.replace(/-/g, "/")), 
            post.void,
            post.voidReason,
            post.notify
        ])
        worksheet.addTable({
            name: "MyTable",
            ref: "A1",
            style: {
                showRowStripes: true,
            },
            columns: [
                { name: "Project Name", filterButton: true}, 
                { name: "Start Date", filterButton: true}, 
                { name: "End Date", filterButton: true}, 
                { name: "Stats", filterButton: true}, 
                { name: "Code", filterButton: true}, 
                { name: "Priority", filterButton: true}, 
                { name: "Pending on Other Department", filterButton: true}, 
                { name: "Supplementary Report", filterButton: true}, 
                { name: "File", filterButton: true}, 
                { name: "Report Tech", filterButton: true}, 
                { name: "Satus", filterButton: true}, 
                { name: "Notes", filterButton: true}, 
                { name: "Approver", filterButton: true}, 
                { name: "Approver Notes", filterButton: true}, 
                { name: "Submitter", filterButton: true}, 
                { name: "Submit Time", filterButton: true}, 
                { name: "Updater", filterButton: true}, 
                { name: "Update Time", filterButton: true}, 
                { name: "Void", filterButton: true}, 
                { name: "Void Reason", filterButton: true}, 
                { name: "Notify", filterButton: true}
            ],
            rows: rows,
        });
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `reprots export ${(new MyDate()).s()}.xlsx`);
            setShowLoader(false);
        })
    }
    return(
        <span className = "pointer" onClick = {exportFunc}>Export</span>
    )
}